// extracted by mini-css-extract-plugin
export default {"invalid-error":"ElectronicsInsuranceForm_invalid-error__3x9iK","submitBtn":"ElectronicsInsuranceForm_submitBtn__+iGhp"};